import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import { useFetchVideoGallery } from '../hooks/useAppInit';
import '../stylings/VideoGalleryAll.css';

const fallback = [
  { _id: 'v1', title: 'Fancy Dress Competition',              videoUrl: 'https://youtu.be/GakocQD9S28' },
  { _id: 'v2', title: 'Christmas Celebration',                videoUrl: 'https://youtu.be/mFPuVSQ392Y' },
  { _id: 'v3', title: 'Annual Function – November 2019',      videoUrl: 'https://youtu.be/UMbds2vGShs' },
  { _id: 'v4', title: "Bal Diwas – Children's Day",          videoUrl: 'https://youtu.be/GZ3cX7jahJ0' },
  { _id: 'v5', title: 'Republic Day Celebration – Part 4',    videoUrl: 'https://youtu.be/eaNj80dma2M' },
  { _id: 'v6', title: 'School Cultural Event Highlights',     videoUrl: 'https://youtu.be/us_KpB47R1o' },
];

function getYoutubeId(url) {
  if (!url) return null;
  const m = url.match(/(?:embed\/|v=|youtu\.be\/)([^?&"'>]+)/);
  return m ? m[1] : null;
}

function getThumb(url) {
  const id = getYoutubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
}

export default function VideoGalleryAll() {
  useFetchVideoGallery();
  const videos = useSelector((state) => state.videoGallery.videos);
  const items = videos.length > 0 ? videos : fallback;

  const [search, setSearch] = useState('');
  const [modalId, setModalId] = useState(null);
  const [modalTitle, setModalTitle] = useState('');
  const backdropRef = useRef(null);

  const filtered = items.filter((v) => v.title.toLowerCase().includes(search.toLowerCase()));

  function openModal(video) {
    const id = getYoutubeId(video.videoUrl);
    if (id) { setModalId(id); setModalTitle(video.title); }
  }
  function closeModal() { setModalId(null); setModalTitle(''); }
  function onBackdropClick(e) { if (e.target === backdropRef.current) closeModal(); }

  return (
    <Layout bannerTitle="Video Gallery">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Video Gallery" />

          <div className="vga-search-bar mt-4">
            <span className="vga-search-icon">&#128269;</span>
            <input
              type="text"
              placeholder="Search videos..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="vga-count mt-2">
            {filtered.length} video{filtered.length !== 1 ? 's' : ''} found
          </div>

          <div className="row g-4 mt-1">
            {filtered.map((video, idx) => {
              const thumb = video.thumbnail || getThumb(video.videoUrl);
              return (
                <div key={video._id} className="col-lg-4 col-md-6">
                  <button className="vga-card" onClick={() => openModal(video)}>
                    <div className="vga-thumb-wrapper">
                      {thumb
                        ? <img src={thumb} alt={video.title} className="vga-thumb" />
                        : <div className="vga-thumb-placeholder"><span>&#127916;</span></div>
                      }
                      <div className="vga-overlay" />
                      <div className="vga-play-btn">
                        <span className="vga-play-triangle">&#9654;</span>
                      </div>
                      <span className="vga-num-badge">#{idx + 1}</span>
                    </div>
                    <div className="vga-info">
                      <p className="vga-title">{video.title}</p>
                      <span className="vga-watch">Watch Now &#9654;</span>
                    </div>
                  </button>
                </div>
              );
            })}
          </div>

          {filtered.length === 0 && (
            <div className="vga-empty">
              <span>&#127916;</span>
              <p>No videos found.</p>
            </div>
          )}
        </div>
      </section>

      {/* ── Fullscreen YouTube Modal ── */}
      {modalId && (
        <div className="vga-modal-backdrop" ref={backdropRef} onClick={onBackdropClick}>
          <div className="vga-modal-box">
            <div className="vga-modal-header">
              <span className="vga-modal-title">{modalTitle}</span>
              <button className="vga-modal-close" onClick={closeModal} aria-label="Close">&#10005;</button>
            </div>
            <div className="vga-modal-embed">
              <iframe
                src={`https://www.youtube.com/embed/${modalId}?autoplay=1&rel=0&modestbranding=1`}
                title={modalTitle}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
